<template>
  <div  >
    
<img class="tamanho_programa"  :src="url_programa">
 

  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false
    };
  },
  created() {
    console.log(this.$store.state.gradecurricular.Setargradecurricular);
  },
  computed: {
    url_programa() {
      return this.$store.state.gradecurricular.Setargradecurricular.caminho;
    }
  },
  methods: {
    abrir_modal() {
      this.showModal = true;
    }
  }
};
</script>

<style lang="css" scoped>
.tamanho_programa{
    max-width: 820px;
}
</style>